import { render, staticRenderFns } from "./withdrawalDetail.vue?vue&type=template&id=00045b66"
import script from "./withdrawalDetail.vue?vue&type=script&lang=js"
export * from "./withdrawalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports